const { format: formatPercent } = Intl.NumberFormat('pt-BR', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
})

export const Mask = {
  onlyDigits: (value) => {
    const decimal = Number(value.toString().replace(/\D/g, ''))
    return decimal
  },
  money: (value, numDecimals) => {
    if (numDecimals == null) numDecimals = 2
    value = parseFloat(value)
    const { format: formatCurrency } = Intl.NumberFormat('pt-BR', {
      currency: 'BRL',
      style: 'currency',
      minimumFractionDigits: numDecimals,
      maximumFractionDigits: numDecimals,
    })

    if (value === null) {
      value = 0
    }
    value = typeof value === 'number' ? value.toFixed(numDecimals) : value

    const decimal = Number(value.replace(/\D/g, '')) / Math.pow(10, numDecimals)
    return formatCurrency(decimal || 0).replace(' \xa0', '')
  },

  percent: (value) => {
    if (value === null) {
      value = 0
    }
    value = typeof value === 'number' ? value.toFixed(2) : value
    const decimal = Math.abs(Number(value.replace(/\D/g, ''))) / 100
    const formattedPercent = formatPercent(decimal || 0).replace('\xa0', '')
    const sign = value < 0 ? '-' : '' // Verifica se o valor é negativo
    return `% ${sign}${formattedPercent}`
  },
}
